// extracted by mini-css-extract-plugin
module.exports = {"button":"_025a50318d--button--35BI8","primary":"_025a50318d--primary--Es3ar","secondary":"_025a50318d--secondary--3lhFG"};